import { useLazyQuery, useMutation, useQuery }                                                                           from '@apollo/client'
import { ArrowUturnLeftIcon }                                                                                            from '@heroicons/react/24/solid'
import { useEffect }                                                                                                     from 'react'
import { useDispatch, useSelector }                                                                                      from 'react-redux'
import { useNavigate }                                                                                                   from 'react-router-dom'
import { Button }                                                                                                        from '../../../components'
import { LoadingEllipsis }                                                                                               from '../../../components/Loaders'
import SettingsVariantVariationForm
                                                                                                                         from '../../../components/Settings/ShopSettings/SettingsVariantVariationForm'
import { setShopVariants, setShopVariantsVariations }                                                                    from '../../../features/shop/shopSlice'
import { setToasts, showToaster }                                                                                        from '../../../features/toaster/toasterSlice'
import { CREATE_SHOP_VARIANT_VARIATION, GET_SHOP_VARIANTS, GET_SHOP_VARIANTS_VARIATIONS, UPDATE_SHOP_VARIANT_VARIATION } from '../../../graphql/shop'
import MainLayout                                                                                                        from '../../../layouts/MainLayout'

export default function SettingsShopVariantsVariations(): JSX.Element {
  const navigate: any               = useNavigate()
  const dispatch: any               = useDispatch()
  const shopVariants: any           = useSelector( ( state: any ): any => state.shop.variants )
  const currentUser: any            = useSelector( ( state: any ): any => state.currentUser.user )
  const shopVariantsVariations: any = useSelector( ( state: any ): any => state.shop.variantsVariations )

  const { loading, refetch } = useQuery( GET_SHOP_VARIANTS_VARIATIONS, {
    onCompleted: ( { shopVariantsVariations }: any ): void => dispatch( setShopVariantsVariations( shopVariantsVariations ) )
  } )

  const [ getShopVariants, { loading: fetchingVariants } ] = useLazyQuery( GET_SHOP_VARIANTS, {
    onCompleted: ( { shopVariants }: any ): void => dispatch( setShopVariants( shopVariants ) )
  } )

  const [ createShopVariantVariation, { loading: creating } ] = useMutation( CREATE_SHOP_VARIANT_VARIATION, {
    onCompleted: (): void => dispatchMessage( 'success', 'New shop variant variation created!' ),
    onError:     (): void => dispatchMessage( 'error', 'Creating failed. Please try again' )
  } )

  const [ updateShopVariantVariation, { loading: updating } ] = useMutation( UPDATE_SHOP_VARIANT_VARIATION, {
    onCompleted: (): void => dispatchMessage( 'success', 'Shop variant variation updated!' ),
    onError:     (): void => dispatchMessage( 'error', 'Update failed. Please try again' )
  } )

  const dispatchMessage: any = ( type: string, message: string ): void => {
    dispatch( setToasts( [ { id: '1', type, message } ] ) )
    dispatch( showToaster( true ) )
  }

  const handleFormSubmit: any = async ( name: string, variant_id: string, id: string ): Promise<any> => {
    const formData: any = { name, variant_id }
    const variant: any = shopVariants.find( ( variant: any ): any => variant.id === variant_id )

    if ( !variant ) return dispatchMessage( 'error', 'Invalid shop variant id!' )

    formData.variant_type = variant.slug

    if ( id.length ) {
      formData.id = id
      await updateShopVariantVariation( { variables: { input: formData } } )
    } else {
      await createShopVariantVariation( { variables: { input: formData } } )
    }

    await refetch()
  }

  useEffect( (): any => {
    let shouldFetch: boolean = true

    if ( shouldFetch && !shopVariants?.length ) {
      getShopVariants()
    }

    return (): void => {
      shouldFetch = false
    }
  }, [ shopVariants ] )

  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">
          { !currentUser && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4 mt-4 w-full" /> }
          { currentUser?.admin &&
            <>
              <div className="w-24 my-4">
                <Button
                  label="Back"
                  blue
                  onClick={ (): any => navigate( -1 ) }
                  icon={ <ArrowUturnLeftIcon className="w-4 h-4" /> }
                />
              </div>

              { ( loading || creating || updating || fetchingVariants ) && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4" /> }

              { ( !loading && !creating && !updating && !fetchingVariants ) && shopVariants &&
                <>
                  { shopVariantsVariations?.map( ( variation: any, index: any ): any =>
                                                                   <SettingsVariantVariationForm
                                                                     handleFormSubmit={ handleFormSubmit }
                                                                     variation={ variation }
                                                                     shopVariants={ shopVariants }
                                                                     key={ index }
                                                                   /> ) }

                  <SettingsVariantVariationForm handleFormSubmit={ handleFormSubmit } namePlaceholder="Type new variation name" shopVariants={ shopVariants } />
                </>
              }
            </>
          }
          { !currentUser?.admin &&
            <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-3 xl:p-4">
              Access Denied!
            </div>
          }
        </div>
      </div>
    </MainLayout>
  )
}
